export default __webpack_public_path__ + "static/media/vuesax-linear-ticket-discount.74032bac.svg";